import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CommonCodesResponse } from '../api/photoApi';

export interface UserTagItem {
  userTagId: number;
  tagValue: string;
}

interface PhotoCommonState {
  commonCodes: CommonCodesResponse | null;
  userTags: UserTagItem[];
  setCommonCodes: (codes: CommonCodesResponse) => void;
  setUserTags: (tags: UserTagItem[]) => void;
}

export const usePhotoCommonStore = create<PhotoCommonState>()(
  persist(
    (set) => ({
      commonCodes: null,
      userTags: [],
      setCommonCodes: (codes) => set({ commonCodes: codes }),
      setUserTags: (tags) => set({ userTags: tags }),
    }),
    { name: 'photo-common-codes' },
  ),
);
